(function () {
  function showDrawer() {
    customElements.whenDefined('mm-cart-drawer').then(() => {
      const drawer = document.querySelector('mm-cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showDrawer);
  } else {
    showDrawer();
  }
})();
